/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import './index.scss'
import { Link, useNavigate } from 'react-router-dom'
import ButtonComponent from '../../../components/Button'
import InputComponent from '../../../components/Input'
import { MdEmail } from "react-icons/md";
import { MdPassword } from "react-icons/md";
import Logo from '../../../assets/img/brand-logo.png'
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from 'react-redux'
import { onSuccessLogin } from '../../../store/actions/user-action'


const LoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const validationSchema = Yup.object({
        phoneNumber: Yup.string()
            .matches(/^[0-9]{10}$/, "Phone is not valid")
            .required("Phone is required"),
        password: Yup.string().required("Password is required"),
    });

    const formik = useFormik({
        initialValues: {
            password: "",
            phoneNumber: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            dispatch(onSuccessLogin(values, navigate))
        },
    });

    return (
        <div className="flex min-h-screen">
            <div className="hidden lg:block lg:w-1/2 amir">

            </div>
            <div className="w-full lg:w-1/2 bg-light_orange flex items-center justify-center p-4">

                <div className="w-full max-w-md bg-white border border-solid flex flex-col p-6 rounded-md">
                        <img src={Logo} className='mx-auto mb-4' width={100} />
                        <h3 className='font-medium text-lg sm:text-xl'>Welcome Back</h3>
                        <p className='text-sm text-[#595858] mt-2'>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate. </p>
                    {/* From start from here */}
                    <form className='mt-5' onSubmit={formik.handleSubmit}>
                        <div className="space-y-4">
                            <div className="">
                                <label htmlFor="phoneNumber" className="block text-sm font-medium leading-6 text-gray-900 mb-2">Phone/Email</label>
                                <InputComponent
                                    value={formik.values.phoneNumber}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.phoneNumber && formik.errors.phoneNumber}
                                    icon={<MdEmail />}
                                    type="text"
                                    name={"phoneNumber"}
                                    placeholder="Email/phone number" />
                                {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                                    <div className="text-red-500 text-sm font-medium mt-1">
                                        {formik.errors.phoneNumber}
                                    </div>
                                ) : null}
                            </div>

                            <div className="">
                                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900 mb-2">Password</label>
                                <InputComponent
                                    icon={<MdPassword />}
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.password && formik.errors.password}
                                    type="password"
                                    name={"password"}
                                    placeholder="Enter Password" />
                                {formik.touched.password && formik.errors.password ? (
                                    <div className="text-red-500 text-sm font-medium mt-1">
                                        {formik.errors.password}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className='mt-6'>
                            <ButtonComponent
                                text="Login" />
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}

export default LoginPage